import { StrictMode, FC, useEffect, useState } from 'react';

import './app.css';
import './design-system.css';
import { Loader } from '@servicetitan/web-components';

export const App: FC = () => {
    const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [userClaims, setUserClaims] = useState<any>(null);
    const params = Object.fromEntries(  
        new URLSearchParams(window.location.search)
      )

    useEffect(() => {
        const checkUserStatus = async () => {
            const req = new Request("/bff/user", {
                headers: new Headers({
                    "X-CSRF": "1",
                }),
            });

            try {
                const resp = await fetch(req);
                console.log(req);
                console.log(resp)
                if (resp.ok) {
                    const claims = await resp.json();
                    setUserClaims(claims);
                    setIsAuthenticated(true);
                    console.log("User is logged in", claims);
                } else if (resp.status === 401) {
                    console.log("User is not logged in");
                    setIsAuthenticated(false);
                }
            } catch (e) {
                console.log("Error occurred while checking user status", e);
                setIsAuthenticated(false);
            } finally {
                setIsLoading(false);  // Done checking user status
            }
        };

        checkUserStatus();
    }, []);

    const login = () => {
        console.log("Login button clicked, redirecting to login");
        window.location.href = `/bff/login`; // Redirect to login endpoint
    };

    if (isLoading) {
        // Optionally display a loading spinner or message while checking authentication
        return <div>Loading...</div>;
    }

    console.log(isAuthenticated)
    return (
        <StrictMode>
            {isAuthenticated ? (
                <>
                    <Loader src={'https://unpkg.servicetitan.com/@servicetitan/financing-technician-application'}
                        data={params}
                        loadingFallback={null} 
                    />
                </>
            ) : (
                <div>
                    <p>You are not authenticated</p>
                    <button onClick={login}>Login</button>
                </div>
            )}
        </StrictMode>
    );
};
